import { memo } from "react";
import { createMimicMessageContext, MimicMessageProviderProps } from "../MimicMessageContext";
import { NotificationProps } from "./Notification";
import { NotificationsContainer } from "./NotificationsContainer";

const { useControls, useMessages, MessageProvider } = createMimicMessageContext<NotificationProps>(
  (allProps, userProps) => {
    return {
      ...allProps,
      autoClose: userProps.autoClose === undefined
        ? userProps.type !== "error"
        : userProps.autoClose,
      autoCloseTimeout: userProps.autoCloseTimeout === undefined
        ? (userProps.type !== "error" ? 5000 : undefined)
        : userProps.autoCloseTimeout,
    };
  },
);

export const useNotification = () => useControls();
export const useNotificationMessages = () => useMessages();

export type NotificationProviderProps = MimicMessageProviderProps<NotificationProps>;
export const NotificationProvider = memo<NotificationProviderProps>((
  {
    children,
    ...props
  },
) => {
  return (
    <MessageProvider {...props}>
      {children}
      <NotificationsContainer />
    </MessageProvider>
  );
});